/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { number as codecNumber, string as codecString } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseCommentReply } from './BaseCommentReply';
const NonDeletedCommentReplyParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['comment', codecString],
    ['authorId', /* #__PURE__ */ parsers.maybeNull(codecNumber), 'author_id'],
    ['deleted', /* #__PURE__ */ parsers.exactly(false)],
]), BaseCommentReply);
export class NonDeletedCommentReply extends BaseCommentReply {
    static decode(input) {
        return NonDeletedCommentReplyParser.decode(input).map(res => new NonDeletedCommentReply(res));
    }
    static unsafeDecode(input) {
        return NonDeletedCommentReply.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return NonDeletedCommentReplyParser.encode(data);
    }
    static schema() {
        return NonDeletedCommentReplyParser.schema();
    }
}
